module.exports = __webpack_public_path__ + "static/media/nightclub.3e6e776d.jpg";